
export type TUser = {
    Id: number,
    Name: string,
    Phone: string,
    Password: string,
    GameInfo?: TGameInfo,
    Type: EUserType,
    Cathegory?: ECathegory
}


export type TInfoMessage = {
    type: EInfoMessageType,
    message: string,
    timeout?: number
}

export type TCookie = {
    name: string,
    value: string
}

export type TForumMessage = {
    Message: string,
    Author: string,
    Date?: string
}

export enum EInfoMessageType {
    SUCCESS = "success",
    ERROR = "error",
    ALERT = "alert"
}

export enum EUserType {
    ADMIN = 1,
    TEAM = 0,
    CANCELLED = 2
}

export type TCypher = {
    Id: number,
    name: string,
    type: ECypherType,
    message?: string,
    helps?: THelp[],
    hasPdf?: boolean,
    points?: number,
    stars?: number,
    votes?: number,
    comments?: TForumMessage[],
    teams?: number
}

export type THelp = {
    Id: number,
    help: string,
    points: number,
    cypher: number,
    type: EHelpType,
    order: number,
    name?: string,
    teams?: number
}

export enum EHelpType {
    NORMAL = "N",
    INSTRUCTIONS = "I",
    ABSOLUTE = "A",
    MINI = "M"
}

export enum ECypherType {
    CYPHER = "C",
    BONUS = "B",
    START = "S", 
    FINISH = "F"
}



export enum EPage {
    WEBYSTEM = "websystem",
    STATS = "stats",
    HISTORY = "history",
    ADMIN = "admin",
    OVERVIEW = "overview"
}

export type TGameInfo = {
    cypher?: number,
    message?: string,
    Status?: number,
    points?: number,
    totalTime: Date
}

export type TStats = {
    cyphers: TCypher[],
    teams: TUser[],
    teamCyphers: {
        id_team: number,
        id_cypher: number,
        time: Date,
        minusPoints: number
    }[],
    teamHelps: {
        id_team: number,
        help: THelp
    }[]
}

export type THistory = {
    time: Date,
    code: string,
    message: string,
    type: string,
}

export enum ECathegory {
    Z = "Z",
    P = "P"
}

export type TSelect<K extends string | number> = {
    key: K,
    label: string
}